export function spaceRemover (string) {
  if(string){
    return string.replace(/ /g, '')
  }
}